/**
 * user module
 */
export default {
  'views/user': () => import('@/views/user/index.vue'),
};
